import { Auth0ContextInterface, User } from "@auth0/auth0-react";
import IUserClaim from "../models/IUserClaim";
import { IAuthenticationContext } from "../auth/IAuthenticationContext";

const CONNECTION_KEY = "https://auth.brandbank.com/connection";
const USER_KEY = "https://auth.brandbank.com/user";
const SERVICES_KEY = "https://auth.brandbank.com/services";

/*******************
 @purpose : user to get token
 @Parameter : {}

 ******************/
export const getIdToken = async (props: Auth0ContextInterface<User>) => {
  const { getAccessTokenSilently } = props;
  try {
    var userClaim = await getUserIdTokenClaims(props);
    if (userClaim.hasClaim) {
      return userClaim.claim;
    }

    await getAccessTokenSilently();

    userClaim = await getUserIdTokenClaims(props);
    if (userClaim.hasClaim) {
      return userClaim.claim;
    }

    window.location.reload();
  } catch (e) {
    console.error(e);
  }
};

const getUserIdTokenClaims = async (
  props: Auth0ContextInterface<User>
): Promise<IUserClaim> => {
  const { getIdTokenClaims } = props;
  let claims = await getIdTokenClaims();

  if (claims && claims.__raw && typeof claims.__raw != "undefined") {
    const userClaim: IUserClaim = { claim: claims.__raw, hasClaim: true };
    return userClaim;
  }

  return { claim: "", hasClaim: false };
};

/*******************
 @purpose : user to get connection url
 @Parameter : {}

 ******************/
export const getConnection = async (props: Auth0ContextInterface<User>) => {
  try {
    const { getIdTokenClaims } = props;
    let claims = await getIdTokenClaims();
    if (
      claims &&
      claims[CONNECTION_KEY] &&
      typeof claims[CONNECTION_KEY] != "undefined"
    ) {
      return JSON.parse(claims[CONNECTION_KEY]);
    }
    return null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/*******************
 @purpose : user to get userclaims url
 @Parameter : {}

 ******************/
export const getUserClaims = async (props: Auth0ContextInterface<User>) => {
  try {
    const { getIdTokenClaims } = props;
    let claims = await getIdTokenClaims();
    if (claims && claims[USER_KEY] && typeof claims[USER_KEY] != "undefined") {
      return JSON.parse(claims[USER_KEY]);
    }
    return null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/*******************
 @purpose : user to get connection url
 @Parameter : {}

 ******************/
export const getServices = async (props: Auth0ContextInterface<User>) => {
  try {
    const { getIdTokenClaims } = props;
    let claims = await getIdTokenClaims();
    if (
      claims &&
      claims[SERVICES_KEY] &&
      typeof claims[SERVICES_KEY] != "undefined"
    ) {
      return JSON.parse(claims[SERVICES_KEY]);
    }
    return null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/*******************
 @Purpose : used to generate random number for sessionID
 @Parameter : length

 ******************/
export const randomNumbers = (length = 10) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

/*******************
 @purpose : get user full name
 @Parameter : {}

 ******************/
export const getUserFullName = async (props: Auth0ContextInterface<User>) => {
  try {
    let userClaims = await getUserClaims(props);
    return userClaims.firstName + " " + userClaims.lastName;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/*******************
 @purpose : get user roles
 @Parameter : {}

 ******************/
export const getUserRoles = async (props: Auth0ContextInterface<User>) => {
  try {
    let services = await getServices(props);

    const userPortalServiceCode = services.find(
      (item: { serviceCode: string }) => item.serviceCode === "BB-USER"
    );

    if (userPortalServiceCode && userPortalServiceCode.subcodes) {
      let roles = userPortalServiceCode.subcodes.flatMap((sc: any) => sc.roles);

      return roles;
    }
    return [];
  } catch (e) {
    console.error(e);
    return null;
  }
};

let audience = process.env.REACT_APP_AUDIENCE;
let scope = process.env.REACT_APP_SCOPE;

export const getAccessToken = async (authContext: IAuthenticationContext) => {
  try {
    const { getAccessTokenSilently } = authContext;
    let token = await getAccessTokenSilently({
      authorizationParams: {
        audience: audience,
        scope: scope,
        
      }
    });
    return token;
  } catch (e) {
    console.log("Invalid Access Token ", e);
  }
};